/**
 * TunnelPage.tsx
 * Page wrapper for the new Tunnel UI experience
 * Bucket 1: Route wiring - feature-flagged access to new GM UI
 */
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import TunnelShell from '../components/tunnel/TunnelShell';
import { FEATURE_FLAGS } from '../config/featureFlags';

export const TunnelPage: React.FC = () => {
  const { poolId } = useParams<{ poolId: string }>();
  
  // Feature flag gate - redirect to legacy if Tunnel is disabled
  if (!FEATURE_FLAGS.ROSTER_TUNNEL) {
    return <Navigate to={`/pools/${poolId}/gm`} replace />;
  }
  
  if (!poolId) {
    return (
      <div className="p-4 text-center text-red-500">
        Error: No pool ID provided
      </div>
    );
  }

  return <TunnelShell poolId={poolId} />;
};

export default TunnelPage;